import axios from '@/axios';

// URL and endpoint constants
// Subjects
const DEMO_URL = '/demo';

export default {
  // GET
  index() {
    return axios.get(DEMO_URL);
  },
  // POST
  submit(data) {
    return axios.post(DEMO_URL, data);
  },
};



// WEBPACK FOOTER //
// ./src/api/demo.js